<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE -->
  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <!-- TITLE -->
      <div class="title alicent">
        A taste of what we're good at
      </div>
    </div>
  </div>

  <!-- ROW MONITO & DDE -->
  <div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv">
    <!-- MONITO -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_monito.webp" alt="app with monitoring">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">
          The built-in <span>Data Monitoring option</span> enables select Sponsor or CRO users
          to submit
          a query to every piece of information entered by site users. The <span>query resolution</span> is then
          carried
          out via a
          <span>user-friendly dialog box</span> between the CRAs and site users. All pages are marked by one of four
          statuses:
          <i><span>incomplete, ready for SDV, SDV done</span>, and <span>signed</span></i>. This allows monitors to
          have
          a
          detailed follow-up of
          sites’ status and gives Project Leaders access to insightful information regarding the project’s progress.
        </p>
        <p data-aos="fade-down-right">
          The <span>sign-off of the CRF</span> a feature available only to Principal Investigators. Once a page, or
          the
          entire CRF, is marked as signed,
          no further modifications can be applied, unless the Sponsor requests a manual un-signing of the form by
          ClinSearch support staff.
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- DDE -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_dde.webp" alt="app with monitoring">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">
          EDClin&trade; can also be used for entering data from <span>paper forms and surveys</span>
          filled Physically on site. All the information is manually entered by our operators and processed through a
          <span>two-step interactive validation algorithm</span>.
        </p>
      </div>
    </div>
  </div>

  <!-- ROW METRICS -->
  <div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv">
    <!-- METRICS -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_metrics.webp" alt="metrics">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">Take <span>any amount of data</span>, sieve it through <span>high-end
            technologies</span>,
          add our <span>clinical trial expertise</span> for crunch, and a generous pinch of penchant for graphic design
          for zing,
          and, voila! Your data can now be filtered, selected, or double-crossed in order to be displayed as
          <span>easy—to—read, catchy infographics</span>
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- img -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <div class="rowdiv wrapper">
          <img class="img-responsive" src="assets/medias/img/illustration2-02.webp" alt="metrics" />
        </div>
      </div>
    </div>
  </div>

  <!-- ROW AUDIT TRAIL -->
  <div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv" dir="rtl">
    <!-- AUDIT TRAIL -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90" dir="ltr">
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_audit.webp" alt="metrics">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">An <span>audit trail</span> is available to all users, keeping track of
          <span>every single modification</span> on each piece of data.
          All changes require the data entry user to explain the reason for the edit, which then becomes available in
          the trail.<br> <br>
          This is not only a fundamental element of compliance with <i><a
              href="https://www.fda.gov/regulatory-information/search-fda-guidance-documents/part-11-electronic-records-electronic-signatures-scope-and-application"
              target="_blank">CFR 21 part 11</a></i>, but it also ensures that CRAs and Project Managers can
          <span>quickly access a summary</span> of why and when
          changes were made.
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- img -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <div class="rowdiv wrapper">
          <img class="img-responsive" src="assets/medias/img/audit_loop_3.gif" alt="audittrail" />
        </div>
      </div>
    </div>
  </div>

<!-- ROW DICOM -->
<div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv">
  <!-- DICOM -->
  <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
    <div class="" data-aos="fade-down-right">
      <img class="titlepng" src="assets/medias/img/pres_dicom.webp" alt="metrics">
    </div>
    <div class="paragraph">
      <p data-aos="fade-down-right">As a result of our multi-year experience in the field of <span>neurosurgery and
          neurovascular interventions</span>, we have established processes for the set-up and management of
        <span> independent committee reviews of imaging data</span>.
        In order to comply with current regulatory and data protection requirements and guarantee the legitimacy of
        the protocol, every image needs to be thoroughly anonymized, to avoid being traced back to the patient.
        <br><br>
      </p>
      <p data-aos="fade-down-right"><b>To this end, we have developed <span>a proprietary tool for the simultaneous
            upload and deidentification of DICOM files</span>. The possibilities it offers are aplenty:</b>
      </p>
      <ul data-aos="fade-down-right">
        <li>To export all your data to a user-friendly Microsoft Office platform (Excel, PDF)</li>
        <li>To export all your data to a statistical analysis-ready format (SAS)</li>
        <li>To generate a PDF version for the CRFs of all patients</li>
        <li>To customize email alerts</li>
        <li>To implement two-factor authentication </li>
      </ul>

    </div>
  </div>

  <!-- SPACER -->
  <div fxFlex.xl="2" fxFlex.lg="2"></div>

  <!-- img -->
  <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
    <div class="" data-aos="fade-down-right">
      <div class="rowdiv wrapper">
        <img class="img-responsive" src="assets/medias/img/app.webp" alt="app" />
      </div>
    </div>
  </div>
</div>


  <!-- ROW DVP & COMPLIANCE & CORECEC -->
  <div fxLayout="row wrap" fxLayoutAlign="center center" class="rowdiv">
    <!-- DVP -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">

      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_dvp.webp" alt="app with dvp">
      </div>
      <div class="paragraph doublerow">
        <p data-aos="fade-down-right">At the base of EDClin&trade; is a customized <span>Data Validation Plan</span>
          which
          delivers
          <span>instant feedback</span>
          to all users through pre-programmed error messages concerning either incoherent or invalid information. These
          <span>built-in coherence checks</span> ensure a faster data collection process with cleaner data.
        </p>
      </div>

      <!-- COMPLIANCE -->
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_compliance.webp" alt="compliance">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">
          All our systems are compliant with <a
            href="https://www.fda.gov/regulatory-information/search-fda-guidance-documents/part-11-electronic-records-electronic-signatures-scope-and-application"
            target="_blank">CFR 21 Part 11</a>.
          EDClin&trade; is developed according
          to <a
            href="https://www.who.int/medicines/areas/quality_safety/quality_assurance/09.08.2018_guideline_validation_computerized_systems_appendix_5_qas16-667_rev2_clean.pdf"
            target="_blank">GAMP5</a>
          recommendations. ClinSearch, the software’s editor, is <span>ISO 9001:2015-certified</span>.
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- CORECEC -->
    <div fxFlex.xl="29" fxFlex.lg="29" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <img class="titlepng" src="assets/medias/img/pres_corecec.webp" alt="app with audit trail">
      </div>
      <div class="paragraph">
        <p data-aos="fade-down-right">As clinical trial methodology constantly evolves towards increasingly
          sophisticated
          <span>validation of collected data by cross-functional expert committees</span>, we have made sure that
          EDClin™
          is <span>adaptable
            to a wide range of integrations</span> for compliant data acquisition and review. Does your protocol
          envision
          the use
          of independent committees for assessing safety and/or performance? We are ready for that.
        </p>
        <p data-aos="fade-down-right">
          <b>CEC/DSMB</b>: The Clinical Events Assessment module of EDClin&trade; gathers all events demanding
          <span>blinded evaluation</span>
          into a <span>dedicated space accessible only to specific users</span>. The randomized selection of assessors,
          which can be fully
          automated, is carried out through a system of email alerts with customizable triggers. Full activity reports
          and
          data visualizations are available at all times.
        </p>
        <p data-aos="fade-down-right">
          <b>CORELAB</b>: The Core Lab module works similarly, only this time the assessed data are patients’ diagnostic
          images.
          Paired with our <span>DICOM platform</span>, this module allows the <span>seamless collection and download of
            deidentified images</span>,
          ready to be imported to any DICOM viewer for further analysis.
        </p>
      </div>
    </div>
  </div>

</div>



<app-footer></app-footer>
